const DocIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 46 56"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2322 1.23222C16.7011 0.7634 17.337 0.5 18 0.5H38C42.1423 0.5 45.5 3.85788 45.5 8V48C45.5 52.1423 42.1423 55.5 38 55.5H8C3.85788 55.5 0.5 52.1423 0.5 48V18C0.5 17.337 0.7634 16.7011 1.23223 16.2322L16.2322 1.23222ZM38 5.5H20.5V18C20.5 19.3807 19.3808 20.5 18 20.5H5.5V48C5.5 49.3807 6.6193 50.5 8 50.5H38C39.3807 50.5 40.5 49.3807 40.5 48V8C40.5 6.6193 39.3807 5.5 38 5.5ZM9.03552 15.5H15.5V9.03552L9.03552 15.5ZM10.5 30.5C10.5 29.1192 11.6193 28 13 28H33C34.3807 28 35.5 29.1192 35.5 30.5C35.5 31.8808 34.3807 33 33 33H13C11.6193 33 10.5 31.8808 10.5 30.5ZM10.5 40.5C10.5 39.1193 11.6193 38 13 38H33C34.3807 38 35.5 39.1193 35.5 40.5C35.5 41.8807 34.3807 43 33 43H13C11.6193 43 10.5 41.8807 10.5 40.5Z"
        fill="black"
      />
    </svg>
  );
};

export default DocIcon;
